import React from 'react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import './AdDelivery.css';
import { useStateValue } from './StateProvider';
import { useRef } from 'react';

function AdDelivery() {
    const [{ admnavagationoption }, dispatch] = useStateValue();
    const [dDetails, setDdetails] = useState([]);
    const [active, setActive] = useState(true);
    const [act, setAct] = useState(true);
    const [dplace, setDplace] = useState('');
    const [dprice, setDprice] = useState('');
    const [did, setDid] = useState();
    const [newdplace, setNewdplace] = useState('');
    const [newdprice, setNewdprice] = useState('');
    const [resp, setResp] = useState('');
    const [respadd, setRespadd] = useState('');
    const [counter, setCounter] = useState(0);

    useEffect(() => {

        axios
            .get('https://toycityzimbabwe.com/backend/getRecentDelivery.php')
            .then(res => {
                setDdetails(res.data)
            })
            .catch( error => {
                console.log(error)
            });
        
    }, [])

    useEffect(() => {

        axios
            .get('https://toycityzimbabwe.com/backend/getRecentDelivery.php')
            .then(res => {
                setDdetails(res.data)
            })
            .catch( error => {
                console.log(error)
            });
        
    }, [counter])

    const hadd = () => {

        if(newdplace !== '' && newdprice !== ''){
            axios
                .get('https://toycityzimbabwe.com/backend/postDelivery.php', {params: {newdplace, newdprice}})
                .then(res => {
                    if(res.data === 'Uploaded Sucessfully')
                    {
                        setResp('Uploaded Sucessfully');
                        
                    }else{
                        setResp('Uploaded Failed '+ res.data)
                    }
                    
                })
                .catch( error => {
                    console.log(error)
                });
                
                setCounter(0);
                setNewdplace('');
                setNewdprice('');
        }else{
            setRespadd('Error')
        }

    }
    

    const hedit = (did, dplace, dprice) => {

        setDplace(dplace);
        setDprice(dprice);
        setDid(did);

        dispatch({
            type: 'SET_ADMNO',
            admnavagationoption: 'three'
        })

        setAct(!act);
        setActive(!active);
    }

    const hdone = () =>{
        axios
            .get('https://toycityzimbabwe.com/backend/updateDelivery.php', {params: {did, dplace, dprice}})
            .then(res => {
                if(res.data === 'Update Sucessfully')
                {
                    setResp('Update Sucessfully');
                    
                }else{
                    setResp('Update Failed '+ res.data)
                }
                
            })
            .catch( error => {
                console.log(error)
            });
            
        setCounter(0);
        setAct(!act);
        setActive(!active);
    }

    const hdelete = (did) => {
        setDid(did);
        dispatch({
            type: 'SET_ADMNO',
            admnavagationoption: 'three'
        })

        setActive(!active);
    }

    const hno = () => {
        setActive(!active);
    }

    const hyes = () => {
        
        axios
            .get("https://toycityzimbabwe.com/backend/deleteDelivery.php", {params: { did }})
            .then(data => {
                if(data.data === 'Record deleted successfully'){
                    setResp('Successfully');
                    setCounter(0);
                }else{
                    setResp('Error')
                }
            })
            .catch(error => console.log(error));

        setActive(!active);
    }

    const hclose = () => {
        setAct(!act);
        setActive(!active);
    }
    

    function useInterval(callback, delay) {

        const savedCallback = useRef();
      
        // Remember the latest callback.
        useEffect(() => {
          savedCallback.current = callback;
        }, [callback]);
      
        // Set up the interval.
        useEffect(() => {
          let id = setInterval(() => {
            savedCallback.current();
          }, delay);
          return () => clearInterval(id);
        }, [delay]);

        
    }

    useInterval(() => {
        setCounter(counter + 1);
    }, 1000);

    return (active
        ?
        <div className='addelivery'>
            <h1>Delivery</h1>

            <table class="c">
                <tr>
                    <th>Place to Deliver</th>
                    <th>Price</th>
                </tr>
                <tr>
                    <td><input type="text" value={newdplace} onChange={e => setNewdplace(e.target.value)} /></td>
                    <td><input type="text" value={newdprice} onChange={e => setNewdprice(e.target.value)} /></td>
                    <td>{respadd}</td>
                    <td><button onClick={hadd}>ADD</button></td>
                </tr>
                {dDetails.map(item => ( 
                    <tr id={item.id}>
                        <td id={item.id}>{item.dplace}</td>
                        <td id={item.id}>{'$'+item.dprice}</td>
                        <td id={item.id}><button onClick={() => hedit(item.did, item.dplace, item.dprice)}>Edit</button></td>
                        <td id={item.id}><button onClick={() => hdelete(item.did)}>Delete</button></td>
                    </tr>
                ))}
            </table>
        </div>
        :
        act 
        ?<div className="addelivery__delete">
            <h4 className='product__delete'>{'Delete?'}</h4>
            <div className="product__btn">
                <button onClick={hyes}>Yes</button>
                <button onClick={hno}>No</button>
            </div>
            {
                resp
            }
        </div>
        :
        <div className='addelivery__edit'>
            <button onClick={hclose}>X</button>
            <div className='__edit'>
                <label className='editlabel'>Place</label>
                <label className='editlabel'>Price</label>
            </div>
            <div className='__edit'>
                <input type="text" value={dplace} onChange={e => setDplace(e.target.value)} />
                <input type="text" value={dprice} onChange={e => setDprice(e.target.value)} />
            </div>
            <button onClick={hdone}>done</button>
        </div>
    )
}

export default AdDelivery;